import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Trans } from '@lingui/macro';

// Shared
import Backdrop from '../../../../../../shared/backdropModal';

const modalPortalRoot = document.getElementById('modal-portal-root');

export default class RejectModal extends React.Component<
  {
    onContinue: any;
    onCancel: any;
  },
  {}
> {
  el;

  constructor(props) {
    super(props);

    this.el = document.createElement('div');
  }

  componentDidMount = () => {
    modalPortalRoot.appendChild(this.el);
  };

  componentWillUnmount = () => {
    modalPortalRoot.removeChild(this.el);
  };

  render() {
    const content = (
      <Backdrop>
        <div className="pop-up-wrapper">
          <div className="pop-up-container">
            <h6 className="ml-3">
              <Trans>Refuser l'invitation d'un employeur</Trans>
            </h6>
            <div className="flex v-align">
              <div className="col v-align align-center text-center">
                <img src="/images/icon.svg" alt="" className="anonymous-icon" width="70" />
                <p>
                  <Trans>
                    En refusant cette connexion, vous n'apparaîtrez plus dans les résultats de
                    recherche de cet employeur.
                  </Trans>
                </p>
                <p>
                  <Trans>Voulez-vous continuer ?</Trans>
                </p>
              </div>
            </div>
            <div className="profile-card-buttons-wrapper">
              <div className="profile-card-buttons-cotnainer">
                <a
                  href="#"
                  onClick={this.props.onCancel}
                  className="button outline left-cap grey w-inline-block">
                  <img
                    src="/images/Cancel.svg"
                    width="24"
                    alt=""
                    className="icon-button-profile-card"
                  />
                  &nbsp;<Trans>Annuler</Trans>
                </a>
                <a
                  href="#"
                  onClick={this.props.onContinue}
                  className="button solid right-cap color-accent-1 w-inline-block">
                  <img
                    src="/images/check.svg"
                    width="24"
                    alt=""
                    className="icon-button-profile-card"
                  />
                  &nbsp;<Trans>Continuer</Trans>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Backdrop>
    );

    return ReactDOM.createPortal(content, this.el);
  }
}
